import React from "react"
import Rating, { RatingProps } from "@mui/material/Rating"
import { styled } from "@mui/material"

import IconStarGreen from "assets/icons/star-green.svg"
import IconStarGrey from "assets/icons/star-grey.svg"

import { colors } from "theme"

const RatingComponent = styled((props: RatingProps) => (
  <Rating
    icon={<img src={IconStarGreen} alt="" />}
    emptyIcon={<img src={IconStarGrey} alt="" />}
    {...props}
  />
))(() => ({
  color: colors.persianGreen,

  "& .MuiRating-icon": {
    margin: "0 20px",
  },
  "& .MuiRating-iconActive": {
    transform: "none !important",
  },
}))

export default RatingComponent
